module.exports = __webpack_public_path__ + "img/collection-weddingRingsCeramic.74908a9.jpg";